export const SET_ACTIVE_TAB = "SET_ACTIVE_TAB";
export const OPEN_USER_PROFILE_SIDEBAR = 'OPEN_USER_PROFILE_SIDEBAR';
export const CLOSE_USER_PROFILE_SIDEBAR = 'CLOSE_USER_PROFILE_SIDEBAR';
export const SET_CONVERSATION_NAME_IN_OPEN_CHAT = 'SET_CONVERSATION_NAME_IN_OPEN_CHAT';
export const SET_LAYOUT_MODE = "SET_LAYOUT_MODE";
export const SET_Profile_LAYOUT_MODE = "SET_Profile_LAYOUT_MODE";
export const Get_Profile_LAYOUT_MODE = "Get_Profile_LAYOUT_MODE";